import "../node_modules/primevue/resources/themes/nova/theme.css";
import "../node_modules/primevue/resources/primevue.min.css";
import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import "./font-awesome.module.js";
import "./primevue.module.js";
import "./filters.js";
import { routes } from "./routes.js";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Vue2TouchEvents from "vue2-touch-events";
import i18n from "./i18n";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import VueAppInsights from 'vue-application-insights';

if(process.env.VUE_APP_AI_CONNECTION_STRING)
{
  Vue.use(VueAppInsights, {
    id: 'XXXXXXXX--XXXX-XXXX-XXXXXXXXXXXX',
    baseName: 'TimeRegistrationMobile',
    router: router,
    appInsightsConfig: {
      connectionString: process.env.VUE_APP_AI_CONNECTION_STRING
    }
  });
}

Vue.config.productionTip = false;

Vue.use(Datetime);
Vue.use(VueRouter);
Vue.use(Loading);
Vue.use(Vue2TouchEvents);

Vue.component("datetime", Datetime);

const router = new VueRouter({
  routes,
});

new Vue({
  i18n,
  render: (h) => h(App),
  router,
}).$mount("#app");

document.addEventListener(
  "touchmove",
  function(event) {
    if (event.scale !== 1) {
      try {
        event.preventDefault();
      } catch (e){
        // empty
      }
    }
  },
  false
);
